import { render, staticRenderFns } from "./NumberIndicator.vue?vue&type=template&id=135b3a86&"
import script from "./NumberIndicator.vue?vue&type=script&lang=js&"
export * from "./NumberIndicator.vue?vue&type=script&lang=js&"
import style0 from "./NumberIndicator.vue?vue&type=style&index=0&id=135b3a86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports